
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Footer from './Components/Footer';
import JoinForm from './Components/JoinForm';
import Navbar from './Components/Navbar';
import Blog1 from './Pages/Blog1';
import CBlog1 from './Pages/CBlog1';
import Coaching from './Pages/Coaching';
import Contact from './Pages/Contact';
import Health from './Pages/Health';
import Home from './Pages/Home';
import Japanese from './Pages/Japanese';
import Research from './Pages/Research';
import Stories from './Pages/Stories';

function App() {
  return (
    <div className=" overflow-hidden w-full font-medium text-slate-700">
      <Navbar></Navbar>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/stories' element={<Stories />}></Route>
        <Route path='/japanese' element={<Japanese />}></Route>
        <Route path='/coach' element={<Coaching />}></Route>
        <Route path='/health' element={<Health />}></Route>
        <Route path='/research' element={<Research />}></Route>
        <Route path='/contact' element={<Contact />}></Route>
        <Route path='/home/blog1' element={<Blog1 />}></Route>
        <Route path='/coach/cblog1' element={<CBlog1 />}></Route>
      </Routes>
      <JoinForm id='join' title="JOIN OUR NEWSLETTER" join></JoinForm>
      <Footer></Footer>
    </div>
  );
}

export default App;
